/**
 * Hook that provides a configured {@link ApiClient} instance bound to the
 * current auth session's token provider.
 */

import { useMemo } from 'react';
import { createApiClient, useAuth } from '@scoring/frontend-shared';
import type { ApiClient } from '@scoring/frontend-shared';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

export function useApiClient(): ApiClient {
  const { getIdToken } = useAuth();

  return useMemo(
    () =>
      createApiClient({
        baseUrl: BASE_URL,
        getToken: getIdToken,
      }),
    [getIdToken],
  );
}
